import firebase from 'firebase';
import Vue from 'vue';
import VueFire from 'vuefire';

export function initialise(config) {
  firebase.initializeApp(config);
  Vue.use(VueFire);
}

export function deleteApp() {
  const app = firebase.app();
  return app.delete();
}



// WEBPACK FOOTER //
// ./src/firebase.js